<template>
  <section class="bg-background-neutral-secondary space-y-4 rounded-xl p-4">
    <h3 class="text-text-neutral-primary mb-2 text-lg font-semibold">
      {{ $t('contacts.rules.title') }}
    </h3>
    <div class="flex items-start space-x-3">
      <FreeRadio
        type="checkbox"
        name="agreement-checkbox"
        :checked="isAgreed"
        :class="{ 'contacts-red-checkbox': hasError }"
        @change="emit('onAgree', !isAgreed)"
      />
      <i18n-t
        tag="p"
        keypath="contacts.rules.description.main"
        class="text-sm font-medium"
        :class="
          hasError ? 'text-text-negative-primary' : 'text-text-neutral-tertiary'
        "
      >
        <template #refundExchange>
          <button
            type="button"
            class="contents"
            :class="
              hasError
                ? 'text-text-negative-primary'
                : 'text-text-positive-primary'
            "
            @click="bottomSheet.show(exchangeReturnBsName)"
          >
            {{ $t('contacts.rules.description.refundExchange') }}
          </button>
        </template>
        <template #publicOffer>
          <button
            type="button"
            class="contents"
            :class="
              hasError
                ? 'text-text-negative-primary'
                : 'text-text-positive-primary'
            "
            @click="bottomSheet.show(publicOfferBsName)"
          >
            {{ $t('contacts.rules.description.publicOffer') }}
          </button>
        </template>
      </i18n-t>
    </div>
  </section>
</template>

<script setup lang="ts">
  import { computed, onBeforeMount } from 'vue';
  import useVuelidate from '@vuelidate/core';
  import { required } from '@vuelidate/validators';
  import { FreeRadio } from 'freedom-shared';
  import { controllerModel } from 'shared';

  const props = defineProps<{
    publicOfferBsName: string;
    exchangeReturnBsName: string;
    isAgreed: boolean;
  }>();

  const emit = defineEmits<{
    onAgree: [isAgreed: boolean];
  }>();

  const bottomSheet = controllerModel.useBottomSheet();

  const vuelidate = useVuelidate(
    computed(() => ({
      isAgreed: {
        required,
        isAgreed: (value: boolean) => value,
      },
    })),
    computed(() => ({
      isAgreed: props.isAgreed,
    })),
  );

  const hasError = computed(() => vuelidate.value.isAgreed.$error);

  onBeforeMount(() => {
    emit('onAgree', true);
  });
</script>

<style scoped>
  .contacts-red-checkbox {
    --color-checkbox-border: theme('colors.red.700');
  }
</style>
